import { createRoot } from "react-dom/client";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: "https://7d18993d43e8999ee72d70aa3084388b@o4511270130417664.ingest.us.sentry.io/4511270153027584",
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ],
  // Performance: sample 100% in dev, 10% in prod to control quota
  tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
  // Distributed tracing: only attach trace headers to our own backends
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/smkgckciiiraloftzewn\.supabase\.co\/.*/,
    /^https:\/\/api\.stripe\.com\/.*/,
  ],
  // Session Replay: 0% always, 100% on error (privacy-first, quota-friendly)
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  // Privacy: do not send PII (IP, cookies, headers)
  sendDefaultPii: false,
  environment: import.meta.env.MODE,
  // Tag all events with the umbrella brand; per-app tagging happens later
  // when Fryqnc/Pulsynq/MindLynq routes split.
  initialScope: {
    tags: { app: "wavlynq" },
  },
});

createRoot(document.getElementById("root")!).render(<App />);
